import { useQuery } from '@tanstack/react-query';
import { changePaymentDueDateGetCacheKey } from './change-payment-due-get-cache-key';
import queryFnFactory from './change-payment-due-date-get-query';
export function useChangePaymentDueDateGetQuery({ config, keyProps, queryOptions = {} }) {
    return useQuery({
        queryKey: changePaymentDueDateGetCacheKey(keyProps),
        queryFn: queryFnFactory(config, keyProps),
        retry: false,
        refetchOnMount: 'always',
        ...queryOptions
    });
}
